import { jsxs as y, jsx as r } from "react/jsx-runtime";
import { c as s } from "../../index-C7ezJk5b.js";
import { useCallback as I } from "react";
import "../../base-BUIxijjU.js";
import { cssX as o } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const D = ({
  placeholder: a,
  value: i,
  setValue: m,
  testId: p,
  style: n,
  className: l,
  autoFocus: u,
  onSubmit: t,
  onFocus: c,
  onBlur: f,
  onKeyDown: d,
  onPaste: x,
  children: b
}) => {
  const h = I(
    (e) => {
      e.preventDefault(), t && t();
    },
    [t]
  );
  return /* @__PURE__ */ y(
    "form",
    {
      onSubmit: h,
      className: s(o("TextInput"), l),
      children: [
        b,
        /* @__PURE__ */ r(
          "input",
          {
            type: "text",
            placeholder: a,
            className: s(o("TextInput__field")),
            style: n,
            value: i,
            onChange: (e) => m(e.target.value),
            autoFocus: u,
            onFocus: c,
            onBlur: f,
            onPaste: x,
            onKeyDown: d,
            "data-testid": p
          }
        ),
        /* @__PURE__ */ r("button", { type: "submit", style: { display: "none" }, children: "submit" })
      ]
    }
  );
};
export {
  D as default
};
